import { defineStore } from 'pinia';
import { auditDataset, auditDatasetAsync } from '@vft/core/audit';
import { downloadAuditReport } from '@vft/core/audit/reportBuilder.js';
import { useFileStore } from './fileStore.js';

export const useAuditStore = defineStore('audit', {
  state: () => ({
    result: null,
    groupOverrides: {},
    running: false,
    error: null,
  }),
  getters: {
    hasResult: (s) => !!s.result,
    columnByName: (s) => {
      if (!s.result) return () => null;
      const map = new Map(s.result.columns.map((c) => [c.name, c]));
      return (name) => map.get(name) || null;
    },
  },
  actions: {
    run() {
      const fileStore = useFileStore();
      if (!fileStore.hasData) return;
      this.running = true;
      this.error = null;
      try {
        this.result = auditDataset(
          { headers: fileStore.headers, rows: fileStore.rows },
          { groupOverrides: this.groupOverrides },
        );
      } catch (err) {
        this.error = err?.message || 'Error executant l\'auditoria';
        throw err;
      } finally {
        this.running = false;
      }
    },
    // Variant troçejada amb progrés (no bloqueja el navegador en fitxers grans).
    // onProgress rep { phase, processed, total }.
    async runAsync(opts = {}) {
      const fileStore = useFileStore();
      if (!fileStore.hasData) return;
      this.running = true;
      this.error = null;
      try {
        this.result = await auditDatasetAsync(
          { headers: fileStore.headers, rows: fileStore.rows },
          { groupOverrides: this.groupOverrides },
          opts.onProgress,
        );
      } catch (err) {
        this.error = err?.message || 'Error executant l\'auditoria';
        throw err;
      } finally {
        this.running = false;
      }
    },
    setGroupOverride(fieldName, group) {
      this.groupOverrides = { ...this.groupOverrides, [fieldName]: group };
      if (this.result) this.run();
    },
    download() {
      if (!this.result) return;
      const fileStore = useFileStore();
      downloadAuditReport(this.result, fileStore.fileName);
    },
    reset() {
      this.result = null;
      this.groupOverrides = {};
      this.running = false;
      this.error = null;
    },
  },
});
